
export const Inform = ({ ...props }) => (
<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z" fill="#E0F2FD"/>
<path d="M16.4382 19.7941H21.5457M16.4382 22.4074H19.9328M25.8469 21.4202C25.847 17.8391 25.8468 15.2452 25.8468 11.6641H13.7501C13.7501 17.0841 13.7504 22.5042 13.75 27.9242H19.9328M19.7984 25.0787H26.25M23.1586 21.8267V28.3307M16.4382 14.5677V16.8905C19.0627 16.8905 20.5341 16.8905 23.1586 16.8905V14.5677H16.4382Z" stroke="#222222" stroke-linejoin="round"/>
</svg>
)
